/**
 * EB 分栏布局菜单工具（移植 view/mer/src/utils/system.js）
 */
import type { RouteLocationNormalized } from 'vue-router';
import type { CrmebNavMenuItem } from '@/utils/crmebMenu';
import { ensureCrmebPrefix } from '@/utils/crmebMenu';

function getPath(to: RouteLocationNormalized, path: string) {
  const params: string[] = [];
  const query: string[] = [];
  Object.keys(to.params || {}).forEach((item) => {
    params.push(String(to.params[item]));
  });
  Object.keys(to.query || {}).forEach((item) => {
    query.push(`${item}=${to.query[item]}`);
  });
  return path + (params.length ? `/${params.join('/')}` : '') + (query.length ? `?${query.join('&')}` : '');
}

function transferMenu(menu: CrmebNavMenuItem, headerName: string) {
  if (menu.children?.length) {
    return menu.children.reduce<Array<{ path: string; header: string }>>((all, item) => {
      all.push({ path: item.path, header: headerName });
      return all.concat(transferMenu(item, headerName));
    }, []);
  }
  return [{ path: menu.path, header: headerName }];
}

/** 根据当前路由找到顶栏（分栏）菜单 path */
export function getHeaderName(to: RouteLocationNormalized, menuList: CrmebNavMenuItem[]): string | null {
  const allMenus: Array<{ path: string; header: string }> = [];
  menuList.forEach((menu) => {
    const headerName = menu.path || '';
    const menus = transferMenu(menu, headerName);
    allMenus.push({ path: menu.path, header: headerName });
    menus.forEach((item) => allMenus.push(item));
  });
  const path = ensureCrmebPrefix(String((to.meta?.activeMenu as string) || to.path));
  const currentMenu = allMenus.find((item) => {
    if (item.path === path) return true;
    return path === getPath(to, item.path);
  });
  return currentMenu ? currentMenu.header : null;
}

export function getMenuSider(menuList: CrmebNavMenuItem[], headerName = '') {
  if (headerName) {
    return menuList.filter((item) => item.path === headerName);
  }
  return menuList;
}

export function findFirstNonNullChildren(arr: CrmebNavMenuItem[] | null | undefined): CrmebNavMenuItem | null {
  if (!arr?.length) return null;
  const firstObj = arr[0];
  if (!firstObj.children?.length) return firstObj;
  return findFirstNonNullChildren(firstObj.children);
}
